import { get } from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getGoods: params => get({ url: 'catalog/goods', data: params, ssr: true }),
  getGood: (id, req) => get({ url: 'catalog/good', req, data: { id } }),
  getIngredients: () => get({ url: 'catalog/ingredients' }),
  getHalves: () => get({ url: 'catalog/half-to-half' }),
  getActiveIngredients: () => get({ url: 'catalog/active-ingredients' }),
  getUpsale: () => get({ url: 'catalog/upsale', data: withUnauthorizedToken() }),
};
